import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAdminDesktopSections, getAdminTabMeta, AdminTab } from './adminNavigation';

type AdminDesktopSidebarProps = {
  activeTab: AdminTab;
  onSelectTab: (tab: AdminTab) => void;
  tabCounts: Partial<Record<AdminTab, number>>;
  totalTesterUnreadForAdmin: number;
};

const AdminDesktopSidebar: React.FC<AdminDesktopSidebarProps> = ({
  activeTab,
  onSelectTab,
  tabCounts,
  totalTesterUnreadForAdmin
}) => {
  const { t } = useTranslation();
  const ADMIN_DESKTOP_SECTIONS = getAdminDesktopSections(t);
  const ADMIN_TAB_META = getAdminTabMeta(t);

  return (
    <aside className="border-r border-[var(--border-primary)] bg-[var(--bg-input)] px-4 py-6 overflow-y-auto custom-scrollbar">
      <div className="space-y-6">
        {ADMIN_DESKTOP_SECTIONS.map((section) => (
          <div key={section.title} className="space-y-2">
            <p className="px-2 text-3xs font-black uppercase tracking-[0.18em] text-[var(--text-muted)]">{section.title}</p>
            <div className="space-y-1">
              {section.tabs.map((tab) => {
                const tabMeta = ADMIN_TAB_META[tab];
                const TabIcon = tabMeta.icon;
                const isActive = activeTab === tab;
                const countValue = tabCounts[tab] || 0;
                const showCount = countValue > 0;
                return (
                  <button
                    key={tab}
                    onClick={() => onSelectTab(tab)}
                    className={`w-full px-3 py-2.5 rounded-xl border text-left transition-all flex items-center justify-between gap-2 ${isActive
                      ? 'bg-[var(--bg-surface)] border-[var(--border-secondary)] text-[var(--text-primary)]'
                      : 'bg-[var(--bg-surface-alt)] border-[var(--border-secondary)] text-[var(--text-secondary)] hover:bg-[var(--bg-surface)] hover:text-[var(--text-primary)]'
                      }`}
                  >
                    <span className="flex items-center gap-2 min-w-0">
                      <TabIcon size={14} className={isActive ? 'text-[var(--text-primary)]' : 'text-[var(--text-muted)]'} />
                      <span className="text-2xs font-black uppercase tracking-wider truncate">{tabMeta.label}</span>
                    </span>
                    {(showCount || (tab === 'testers' && totalTesterUnreadForAdmin > 0)) && (
                      <span className={`px-2 py-0.5 rounded-full text-3xs font-black ${isActive ? 'bg-white text-black' : 'bg-[var(--bg-input)] text-[var(--text-primary)] border border-[var(--border-secondary)]'}`}>
                        {showCount ? countValue : '•'}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default AdminDesktopSidebar;
